import { EnumAppointmentReminderStatus } from "@bbj-types/action/appointmentReminder";
import { Stack, Typography } from "@mui/material";
import { ReminderStatusIcon } from "./icon";
import { reminderStatusMapping } from "./mapping";

export interface IReminderStatusInfoProps {
  status?: EnumAppointmentReminderStatus;
}

/**
 * Appointment reminder status displayed as a standalone information line (bell icon + label),
 * for the views where the status must not be attached to the action date.
 */
export const ReminderStatusInfo = ({ status }: IReminderStatusInfoProps) => {
  const reminderStatus = status ?? EnumAppointmentReminderStatus.NOT_SCHEDULED;

  return (
    <Stack direction="row" sx={{ gap: 1, alignItems: "start" }}>
      <Stack sx={{ height: 14 * 1.5, justifyContent: "center" }}>
        <ReminderStatusIcon status={reminderStatus} />
      </Stack>
      <Typography>{reminderStatusMapping[reminderStatus].label}</Typography>
    </Stack>
  );
};
